import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  BooleanField,
  DateField,
  ArrayField,
  Datagrid,
  FunctionField,
} from "react-admin";

import { Box, Chip, Typography, Card } from "@mui/material";

const AssessmentResponseShow = () => {
  return (
    <Show>
      <SimpleShowLayout
        sx={{
          maxWidth: "100%",
          "& .RaSimpleShowLayout-stack": {
            gap: 2,
          },
        }}
      >
        {/* HEADER CARD */}
        <Card
          sx={{
            p: 3,
            borderRadius: "16px",
            boxShadow: 2,
            mb: 2,
          }}
        >
          <Typography
            variant="h5"
            fontWeight={700}
            gutterBottom
          >
            Assessment Response
          </Typography>

          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              md: "1fr 1fr",
            }}
            gap={2}
          >
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
              >
                Attempt ID : 
              </Typography>
              <TextField source="attempt_id" />
            </Box>

            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
              >
                Assessment : 
              </Typography>
              <TextField source="assessment_title" />
            </Box>

            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
              >
                Description :
              </Typography>
              <TextField source="description" />
            </Box>

            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
              >
                Submitted At : 
              </Typography>
              <DateField
                source="submitted_at"
                showTime
              />
            </Box>
          </Box>
        </Card>

        {/* SCORE SUMMARY */}
        <Box
          display="flex"
          gap={2}
          flexWrap="wrap"
          mb={2}
        >
          <FunctionField
            label={false}
            render={(record) => (
              <Chip
                label={`Score: ${
                  record.score || 0
                }`}
                color="primary"
                sx={{
                  fontWeight: 600,
                  px: 1,
                }}
              />
            )}
          />

          <FunctionField
            label={false}
            render={(record) => (
              <Chip
                label={`Total: ${
                  record.total_score || 0
                }`}
                color="secondary"
                sx={{
                  fontWeight: 600,
                  px: 1,
                }}
              />
            )}
          />

          <FunctionField
            label={false}
            render={(record) => (
              <Chip
                label={`Percentage: ${
                  record.percentage || 0
                }%`}
                color={
                  record.percentage >= 70
                    ? "success"
                    : "warning"
                }
                sx={{
                  fontWeight: 600,
                  px: 1,
                }}
              />
            )}
          />

          <FunctionField
            label={false}
            render={(record) => (
              <Chip
                label={
                  record.pass_status
                    ? "Passed"
                    : "Failed"
                }
                color={
                  record.pass_status
                    ? "success"
                    : "error"
                }
                sx={{
                  fontWeight: 600,
                  px: 1,
                }}
              />
            )}
          />
        </Box>

        {/* QUESTION RESULTS */}
        <Card
          sx={{
            p: 2,
            borderRadius: "16px",
            boxShadow: 1,
          }}
        >
          <Typography
            variant="h6"
            fontWeight={700}
            mb={2}
          >
            Question Results
          </Typography>

          <ArrayField source="results">
            <Datagrid
              bulkActionButtons={false}
              sx={{
                "& .RaDatagrid-row": {
                  height: 72,
                },
              }}
            >
              <TextField source="question" />

              

              <FunctionField
                label="Your Answer"
                render={(record) => (
                  <Chip
                    label={
                      record.user_answer || "-"
                    }
                    size="small"
                    color="info"
                  />
                )}
              />

              <FunctionField
                label="Correct Answer"
                render={(record) => (
                  <Chip
                    label={
                      record.correct_answer || "-"
                    }
                    size="small"
                    color="success"
                  />
                )}
              />

              <FunctionField
                label="Result"
                render={(record) => (
                  <Chip
                    label={
                      record.is_correct
                        ? "Correct"
                        : "Wrong"
                    }
                    size="small"
                    color={
                      record.is_correct
                        ? "success"
                        : "error"
                    }
                  />
                )}
              />

              <FunctionField
                label="Score"
                render={(record) => (
                  <Chip
                    label={
                      record.score_awarded || 0
                    }
                    size="small"
                    color="primary"
                  />
                )}
              />
            </Datagrid>
          </ArrayField>
        </Card>
      </SimpleShowLayout>
    </Show>
  );
};

export default AssessmentResponseShow;